// src/App.jsx
import "./styles/globals.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Layout from "./components/Layout";
// Existing pages
import OverviewPage from "./pages/OverviewPage";
import CasesManagementPage from "./pages/CasesManagementPage";
import CaseManagement from "./pages/CaseManagement";
import UserManagementPage from "./pages/UserManagementPage";
// New pages
import FeedbackManagementPage from "./pages/FeedbackManagementPage";
import EmailManagementPage from "./pages/EmailManagementPage";

function App() {
    return (
        <Router>
            <Layout>
                <Routes>
                    {/* Overview */}
                    <Route path="/" element={<OverviewPage />} />

                    {/* Cases */}
                    <Route path="/cases" element={<CasesManagementPage />} />
                    <Route path="/cases/new" element={<CaseManagement />} />

                    {/* Users */}
                    <Route path="/users" element={<UserManagementPage />} />

                    {/* Feedback */}
                    <Route
                        path="/feedback"
                        element={<FeedbackManagementPage />}
                    />

                    {/* Email */}
                    <Route path="/email" element={<EmailManagementPage />} />

                    {/* Optionally, add a direct /overview route or any other routes. */}
                </Routes>
            </Layout>
        </Router>
    );
}

export default App;
